import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=a09b72d2&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=ts"
export * from "./breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=a09b72d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09b72d2",
  null
  
)

export default component.exports